export const getMonthShift = (year: number): number => {
    if (year >= 1900 && year <= 1999) {
        return 0;
    }

    if (year >= 1800 && year <= 1899) {
        return 80;
    }

    if (year >= 2000 && year <= 2099) {
        return 20;
    }

    if (year >= 2100 && year <= 2199) {
        return 40;
    }

    if (year >= 2200 && year <= 2299) {
        return 60;
    }

    return 0;
};

export const getIsBirthdateValid = (idDateParts: { RR: number; DD: number; MM: number }, birthdate: string): boolean => {
    const [year, month, day] = birthdate.split('-');
    const { RR, DD, MM } = idDateParts;

    const isYearValid = RR === Number(year) % 100;
    const isDayValid = DD === Number(day);
    const isMonthValid = MM === Number(month) + getMonthShift(Number(year));

    return isDayValid && isMonthValid && isYearValid;
};

export const getIsChecksumValid = (idValue: string, idK: number): boolean => {
    const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    const checksum = idValue.split('')
        .slice(0, 10)
        .map((digit, index) => Number(digit) * weights[index])
        .reduce((result, num) => result + num, 0);

    return idK === (10 - checksum % 10) % 10;
};
